export const ALVA_TOKEN_KEY = 'alva:token';
